export const getGreetingBasedOnTimeOfDay = (): string => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    if (currentHour < 12) {
        return 'Good morning';
    }
    if (currentHour < 17) {
        return 'Good afternoon';
    }
    return 'Good evening';
}